/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type UpdateProjectMutationInput = {
    readonly clientApprovalDate?: string | null;
    readonly installDate?: string | null;
    readonly name?: string | null;
    readonly projectId: string;
    readonly purchaserId?: string | null;
    readonly shippingAddress?: AddressInput | null;
    readonly sourcingStartDate?: string | null;
    readonly clientMutationId?: string | null;
};
export type AddressInput = {
    readonly active?: unknown | null;
    readonly contact?: string | null;
    readonly city?: string | null;
    readonly company?: string | null;
    readonly country?: string | null;
    readonly firstName?: string | null;
    readonly lastName?: string | null;
    readonly label?: string | null;
    readonly line1?: string | null;
    readonly line2?: string | null;
    readonly phoneNumber?: string | null;
    readonly state?: string | null;
    readonly zipCode?: string | null;
};
export type UpdateProjectMutationVariables = {
    readonly input: UpdateProjectMutationInput;
};
export type UpdateProjectMutationResponse = {
    readonly updateProject: {
        readonly project: {
            readonly serviceId: string | null;
            readonly createdDate: string | null;
            readonly installDate: string | null;
            readonly name: string | null;
            readonly portfolio: {
                readonly serviceId: string | null;
                readonly name: string | null;
            } | null;
            readonly purchaserId: string | null;
            readonly shippingAddress: {
                readonly city: string | null;
                readonly country: string | null;
                readonly formattedAddress: ReadonlyArray<string | null> | null;
                readonly line1: string | null;
                readonly line2: string | null;
                readonly state: string | null;
                readonly zipCode: string | null;
            } | null;
            readonly sourcingStartDate: string | null;
            readonly userId: string | null;
        } | null;
    } | null;
};
export type UpdateProjectMutation = {
    readonly response: UpdateProjectMutationResponse;
    readonly variables: UpdateProjectMutationVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "input",
            "type": "UpdateProjectMutationInput!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        } as any)
    ], v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "serviceId",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "createdDate",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "installDate",
        "args": null,
        "storageKey": null
    } as any), v5 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
    } as any), v6 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "purchaserId",
        "args": null,
        "storageKey": null
    } as any), v7 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "city",
        "args": null,
        "storageKey": null
    } as any), v8 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "country",
        "args": null,
        "storageKey": null
    } as any), v9 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "formattedAddress",
        "args": null,
        "storageKey": null
    } as any), v10 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "line1",
        "args": null,
        "storageKey": null
    } as any), v11 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "line2",
        "args": null,
        "storageKey": null
    } as any), v12 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "state",
        "args": null,
        "storageKey": null
    } as any), v13 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "zipCode",
        "args": null,
        "storageKey": null
    } as any), v14 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "sourcingStartDate",
        "args": null,
        "storageKey": null
    } as any), v15 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "userId",
        "args": null,
        "storageKey": null
    } as any), v16 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "UpdateProjectMutation",
            "type": "Mutations",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "updateProject",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "UpdateProjectMutationPayload",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "project",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Project",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                (v3 /*: any*/),
                                (v4 /*: any*/),
                                (v5 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "portfolio",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "PortfolioV2",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/),
                                        (v5 /*: any*/)
                                    ]
                                },
                                (v6 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "shippingAddress",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Address",
                                    "plural": false,
                                    "selections": [
                                        (v7 /*: any*/),
                                        (v8 /*: any*/),
                                        (v9 /*: any*/),
                                        (v10 /*: any*/),
                                        (v11 /*: any*/),
                                        (v12 /*: any*/),
                                        (v13 /*: any*/)
                                    ]
                                },
                                (v14 /*: any*/),
                                (v15 /*: any*/)
                            ]
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "UpdateProjectMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "updateProject",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "UpdateProjectMutationPayload",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "project",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Project",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                (v3 /*: any*/),
                                (v4 /*: any*/),
                                (v5 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "portfolio",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "PortfolioV2",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/),
                                        (v5 /*: any*/),
                                        (v16 /*: any*/)
                                    ]
                                },
                                (v6 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "shippingAddress",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Address",
                                    "plural": false,
                                    "selections": [
                                        (v7 /*: any*/),
                                        (v8 /*: any*/),
                                        (v9 /*: any*/),
                                        (v10 /*: any*/),
                                        (v11 /*: any*/),
                                        (v12 /*: any*/),
                                        (v13 /*: any*/),
                                        (v16 /*: any*/)
                                    ]
                                },
                                (v14 /*: any*/),
                                (v15 /*: any*/),
                                (v16 /*: any*/)
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "mutation",
            "name": "UpdateProjectMutation",
            "id": "app-buyer-misc/230.0.0-2019-08-28T11:54:11.732Z/UpdateProjectMutation",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'f70e5dca11ec109022d24862ce989f1b';
export default node;
